import { useEnvironment } from '#/contexts/UserEnvironmentContext';

const MOBILE_SEARCH_V2_EXPERIMENT = 'MOBILE_SEARCH_V2_B_2026_05';

export function useIsMobileSearchV2Enabled(): boolean {
  const { environment } = useEnvironment();
  return environment.abExperiments.some(
    (e) => e.id === MOBILE_SEARCH_V2_EXPERIMENT && e.bucket === 'ENABLED',
  );
}
